import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";
import { zUsdCents } from "../../currency";

export enum SupportAiBillingVersion {
  /** Bucketed usage - progressive pricing based on volume tiers */
  BUCKETED_USAGE = "bucketed_usage",
  /** Simple AI usage - flat per-resolution rate without volume discounts */
  SIMPLE_AI_USAGE = "simple_ai_usage",
  /** External billing - for record-keeping only when billed through another system */
  EXTERNAL_BILLING = "external_billing",
}

/** Default price per AI resolution in cents for SIMPLE_USAGE billing */
export const DEFAULT_AI_RESOLUTION_PRICE_IN_CENTS = 85;

export const SupportAiBillingZodSchema = z.object({
  version: createEnum(SupportAiBillingVersion, {
    enumName: "SupportAiBillingVersion",
  })
    .nullable()
    .optional(),
  dangerousResolutionPriceOverrideInCents: zUsdCents.nullable().optional(),
  freeTrialEndDate: z.date().nullable().optional(),
  receivedFreeTrial: z.boolean().nullish(),
  atShopifyCap: z.boolean().nullable().optional(),
  ticketsUsed: z.number().nullable().optional(),
  billingStartDate: z.date().nullable().optional(),
  billingAccepted: z.boolean().nullable().optional(),
  oneTimeFreeResolutions: z.number().nullable().optional(),
  recurringFreeResolutions: z.number().nullable().optional(),
  recurringFreeResolutionsEndDate: z.date().nullable().optional(),
  resolutionPercentageDiscount: z.number().nullable().optional(),
  resolutionPercentageDiscountEndDate: z.date().nullable().optional(),
  lastDayActive: z.string().nullable().optional(),
  aiResolutionPriceInCents: z.number().nullable().optional(),
});

export type SupportAiBillingZod = z.infer<typeof SupportAiBillingZodSchema>;
